import React, { useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { updateNode } from "../../Helpers/Nodes";

const OrganizationSelector = ({ organizations, selectedOrg, user }) => {
    const [orgPopup, setOrgPopup] = useState(false);

    const currentOrg = { ...selectedOrg }

    const blurTimeoutRef = useRef();

    const contentRef = useRef();

    const onFocus = () => {
        clearTimeout(blurTimeoutRef.current);
    };
    const onBlurTimeout = () => {
        setOrgPopup(false);
    };
    const onBlur = () => {
        clearTimeout(blurTimeoutRef.current);
        blurTimeoutRef.current = setTimeout(onBlurTimeout, 200);
    };

    const changeOrganization = (e) => {
        if (e.id === null) {
            window.location.href = "/_CreateOrganization";
        } else {
            if (user && user.id) {
                updateNode("user", user.id, {
                    lastOrganizationAccessed: e.name
                })
            }
            localStorage.setItem("selectedOrganization", e.name);
            window.location.href = "/" + e.name;
        }
    };

    return selectedOrg ? (
        <Dropdown className="ms-3">
            <Dropdown.Toggle className="clean-dropdown no-button-hover">
                <div className="header d-flex justify-content-between align-items-center pointer btn-over-black">
                    <span className="font-weight text-dark">
                        {selectedOrg.number}
                    </span>
                    <i className="fal fa-chevron-down down-arrow mx-2"></i>
                </div>
            </Dropdown.Toggle>
            <Dropdown.Menu className="preview-panel-parent">
                <div
                    className="position-relative"
                    style={{ height: 220 }}
                    ref={contentRef}
                    tabIndex={0}
                    onFocus={onFocus}
                    onBlur={onBlur}
                >
                    {/* <div className="border-bottom p-2 popup-grid-row-alt pointer">
                        <input
                            autoFocus={true}
                            type="text"
                            className="form-control"
                            placeholder="Search Organization"
                        />
                    </div> */}
                    <div
                        className="overflow-auto p-2 text-content"
                        style={{
                            height:
                                organizations.findIndex(
                                    (o) => o.number === "CreateOrg"
                                ) > -1
                                    ? 160
                                    : 200,
                        }}
                    >
                        <h6 className="m-2"><strong>My organization</strong></h6>
                        {organizations
                            .filter(
                                (o) =>
                                    o.number !== "CreateOrg" &&
                                    o.roleType === "Owner"
                            )
                            .map((o, i) => (
                                <div
                                    key={"pro" + i}
                                    className="popup-grid-row pointer ms-2"
                                    onClick={() =>
                                        changeOrganization({
                                            id: o.id,
                                            name: o.number,
                                        })
                                    }
                                >
                                    <i className="fas fa-sitemap me-2"></i>
                                    {o.number}
                                </div>
                            ))}
                        <h6 className="m-2"><strong>Other organizations</strong></h6>
                        {organizations
                            .filter(
                                (o) =>
                                    o.number !== "CreateOrg" &&
                                    o.roleType !== "Owner"
                            )
                            .map((o, i) => (
                                <div
                                    key={"pro" + i}
                                    className="popup-grid-row pointer ms-2"
                                    onClick={() =>
                                        changeOrganization({
                                            id: o.id,
                                            name: o.number,
                                        })
                                    }
                                >
                                    <i className="fas fa-sitemap me-2"></i>
                                    {o.number}
                                </div>
                            ))}
                    </div>
                    {organizations.findIndex((o) => o.number === "CreateOrg") >
                        -1 && (
                            <div
                                className="position-absolute bg-light bottom-0 border-top p-2 popup-grid-row-alt pointer text-center"
                                onClick={() => changeOrganization({ id: null })}
                            >
                                <i
                                    style={{ color: "#fd7e14" }}
                                    className="fas fa-plus mx-1"
                                ></i>
                                Create your own organization
                            </div>
                        )}
                </div>
            </Dropdown.Menu>
        </Dropdown>
    ) : (
        <></>
    );
};

export default OrganizationSelector;
